export default __webpack_public_path__ + "static/media/goa1.5827ba91.jpg";